/**
 * We are using axios as our api layer. Each api should return the axios Promise,
 * then within the specific redux action, use the then() methods to
 * dispatch() the specific action for the UI to handle.
 * https://github.com/axios/axios
 * */
import axios from 'axios';

import {GET_ALL_CONVERSATIONS, SWITCH_CONVERSATION} from "../constants/ApiEndpoints";

/**
 * getMessages can take in an optional id param which will return only the new messages sent after that message.
 */
export default class MenuApi {
    static getAllConversations = () => axios.get(GET_ALL_CONVERSATIONS);

    static switchConversation = request => axios.post(SWITCH_CONVERSATION, request);
}